import debounce from 'lodash/debounce';

import {
    setAudioInputDevice
} from '../../../react/features/base/devices/actions';
import { getDeviceLabelById } from '../../../react/features/base/devices/functions.web';
import {
    JitsiConferenceEvents, JitsiMediaDevicesEvents
} from '../../../react/features/base/lib-jitsi-meet';
import { MEDIA_TYPE } from '../../../react/features/base/media/constants';
import { PARTICIPANT_ROLE } from '../../../react/features/base/participants/constants';
import { getParticipantById } from '../../../react/features/base/participants/functions';
import StateListenerRegistry from '../../../react/features/base/redux/StateListenerRegistry';
import { updateSettings } from '../../../react/features/base/settings/actions';
import { getCurrentMicDeviceId } from '../../../react/features/base/settings/functions';
import {
    getLocalJitsiAudioTrack
} from '../../../react/features/base/tracks/functions.any';
import { setFilmstripVisible } from '../../../react/features/filmstrip/actions';
import {
    MUTE_REACTIONS_COMMAND
} from '../../../react/features/reactions/constants';
import { setTileView } from '../../../react/features/video-layout/actions';
import { analyticsEvents } from '../../components/noise-suppression/constants';
import {
    sendAudioAnalytics
} from '../../components/noise-suppression/functions';
import {
    isSharingTabTrack
} from '../../components/wildix-remote-control/functions';
import Env from '../../modules/Environment';
import WildixEvents from '../../service/WildixEvents';
import { showNoAudioNotify } from '../no-audio-notification/actions.web';

let isInitEventSend = false;

/**
 * Listens when the conference state available.
 */
StateListenerRegistry.register(
    state => state['features/base/conference'].conference,
    /* listener */ (conference, { dispatch, getState }) => {
        if (!conference) {
            return;
        }

        hideCounterBandge();

        // Emulate component loaded

        const state = getState();

        if (conference.room) {
            const deviceChangeListener = function(deviceList) {
                const newState = getState();

                const { userSelectedMicDeviceId } = newState['features/base/settings'];
                const isSelectedDeviceExist = getDeviceLabelById(newState, userSelectedMicDeviceId, 'audioInput');

                const storeDeviceID = getCurrentMicDeviceId(newState);

                if (userSelectedMicDeviceId === 'default' || storeDeviceID === 'default' || !isSelectedDeviceExist) {
                    dispatch(setAudioInputDevice('default'));
                }
                sendAudioAnalytics({ dispatch,
                    state: getState(),
                    title: analyticsEvents.DEVICE_LIST_CHANGED,
                    deviceList
                });
            };
            const debouncedCb = debounce(deviceChangeListener, 2000);

            JitsiMeetJS.mediaDevices.addEventListener(JitsiMediaDevicesEvents.DEVICE_LIST_CHANGED,
                debouncedCb);


            APP.wildix.eventEmitter.on(WildixEvents.CONFERENCE_DISPOSE, () => {
                JitsiMeetJS.mediaDevices.removeEventListener(JitsiMediaDevicesEvents.DEVICE_LIST_CHANGED,
                    debouncedCb);
            });
        }


        // WMS-11540 wizy: make video recording more convenient for post-production
        if (config.iAmRecorder) {
            // in case of iAmSipGateway keep local video visible
            if (!config.iAmSipGateway) {
                APP.store.dispatch(setFilmstripVisible(false));

                // Disable sound for recording
                dispatch(updateSettings({
                    soundsParticipantJoined: false,
                    soundsParticipantLeft: false
                }));
            }
        }

        // END WMS-11540 wizy: make video recording more convenient for post-production

        if (APP.wildix.wizy) {
            dispatch(setTileView(false));
        }

        conference.addCommandListener(MUTE_REACTIONS_COMMAND, (data, id) => {

            if (typeof id === 'undefined') {
                return;
            }

            const participantSendingCommand = getParticipantById(state, id);

            if (!participantSendingCommand
                || participantSendingCommand.local
                || participantSendingCommand.role !== PARTICIPANT_ROLE.MODERATOR) {
                return;
            }

            dispatch(updateSettings({ soundsReactions: false }));
        });

        conference.on(JitsiConferenceEvents.TRACK_ADDED, audioJitsiTrack => {
            if (audioJitsiTrack.isLocal()) {

                if (!audioJitsiTrack.isMuted() && !isInitEventSend
                    && audioJitsiTrack.type === MEDIA_TYPE.AUDIO
                    && !isSharingTabTrack(audioJitsiTrack)) {

                    sendAudioAnalytics({ dispatch,
                        state: getState(),
                        title: analyticsEvents.JOIN,
                        audioJitsiTrack
                    });
                    isInitEventSend = true;
                }
            }
        });

        conference.on(JitsiConferenceEvents.TRACK_MUTE_CHANGED, track => {
            if (track.isLocal()) {
                sendAudioAnalytics({ dispatch,
                    state: getState(),
                    title: analyticsEvents.TRACK_MUTE_CHANGED,
                    audioJitsiTrack: track
                });
            }
        });

        conference.on(WildixEvents.SHOW_NOTIFICATION_NO_AUDIO, () => {
            if (Env.isWizyconf()) {
                return;
            }
            dispatch(showNoAudioNotify());
        });

        const audioJitsiTrack = getLocalJitsiAudioTrack(state);

        if (audioJitsiTrack) {
            sendAudioAnalytics({ dispatch,
                state,
                title: analyticsEvents.JOIN,
                audioJitsiTrack });
            isInitEventSend = true;
        }
    }
);
function hideCounterBandge() {
    if (APP.isExternalProvider) {
        return;
    }
    const elCounterChat = document.querySelector('.badge-round');

    if (elCounterChat) {
        elCounterChat.style.opacity = '0';
    }
}
